import { gql } from 'apollo-angular';

export const UPDATE_LOGIN_TIME_MUTATION = gql`
  mutation UpdateLoginTime($loginTime: DateTime!) {
    updateLoginTime(loginTime: $loginTime) {
      data
      isSuccess
      message
      errorCode
    }
  }
`;
